import { addLocaleData } from 'react-intl';
import queryString from 'query-string';

import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import enUS from './en-us';
import esUS from './es-us';

addLocaleData([...en, ...es]);

const allMessages = { enUS, esUS };

export const localeData = (() => {
  // TODO - Pass user's locale via JWT to be decoded and implemented here
  const queryParams = queryString.parse(window.location.search);
  let locale = 'en-US';
  if (queryParams && queryParams.locale) {
    ({ locale } = queryParams);
  }
  const localeMessages = allMessages[locale.replace('-', '')] || allMessages.enUS;

  return { locale, localeMessages };
})();



// WEBPACK FOOTER //
// ./src/i18n/locale.js